<!-- 发票信息 -->
<template>
  <el-form :model="feeInfo" :rules="rules" :disabled="!canEdit" ref="feeInfo" label-width="120px">
    <el-row :gutter="24">
      <!-- 公司代码 -->
      <el-col :span="6">
        <el-form-item
          prop="payableInvoiceCompanyCode"
          :label="this.$t('addInvoice.billInfo.payableInvoiceCompanyCode')"
        >
          <el-select
            filterable
            style="width: 100%"
            v-model="feeInfo.payableInvoiceCompanyCode"
            @change="selectCompany"
            :placeholder="this.$t('addInvoice.billInfo.companyNoPlaceholder')"
            :disabled="detail || fromContract"
          >
            <el-option
              v-for="item in companyList"
              :key="item.id"
              :label="item.personCompanyName"
              :value="item.personCompanyCode"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item
          prop="payableInvoiceCompanyName"
          :label="this.$t('addInvoice.billInfo.payableInvoiceCompanyName')"
        >
          <el-select
            filterable
            style="width: 100%"
            v-model="feeInfo.payableInvoiceCompanyName"
            @change="selectCompany"
            :placeholder="this.$t('addInvoice.billInfo.companyNoPlaceholder')"
            :disabled="detail || fromContract"
          >
            <el-option
              v-for="item in companyList"
              :key="item.id"
              :label="item.personCompanyName"
              :value="item.personCompanyCode"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <!-- 制单人 -->
      <el-col :span="6">
        <el-form-item
          prop="payableInvoiceCreatePerson"
          :label="this.$t('addInvoice.billInfo.payableInvoiceCreatePerson')"
        >
          <search-table
            ref="searchTable"
            disabled
            v-model="feeInfo.payableInvoiceCreatePerson"
            :searchType="'personnel'"
            :isMultiple="true"
            :currentValue="feeInfo.payableInvoiceCreatePersonName"
            :checkRowKeys="feeInfo.payableInvoiceCreatePersonNos || []"
            @input="selectPayableInvoiceCreatePerson"
          ></search-table>
        </el-form-item>
      </el-col>
      <!-- 制单日期 -->
      <el-col :span="6">
        <el-form-item
          prop="payableInvoiceCreateDate"
          :label="this.$t('addInvoice.billInfo.payableInvoiceCreateDate')"
        >
          <el-date-picker
            disabled
            v-model="feeInfo.payableInvoiceCreateDate"
            style="width: 100%"
            type="date"
            value-format="yyyy-MM-dd"
            format="yyyy-MM-dd"
          ></el-date-picker>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="24">
      <!-- 单据状态 -->
      <el-col :span="6">
        <el-form-item
          prop="payableInvoiceStatus"
          :label="this.$t('addInvoice.billInfo.payableInvoiceStatus')"
        >
          <dict-select
            type="payable-invoice-status"
            v-model="feeInfo.payableInvoiceStatus"
            disabled
          ></dict-select>
        </el-form-item>
      </el-col>
      <!-- 开票单位 -->
      <el-col :span="6">
        <el-form-item :label="$t('addInvoice.billInfo.invoiceUnitName')" prop="invoiceUnitName">
          <search-table
            v-model="feeInfo.invoiceUnitName"
            :disabled="fromContract"
            searchType="supplier"
            :isMultiple="true"
            :checkRowKeys="[feeInfo.invoiceUnitName] || []"
            :currentValue="feeInfo.invoiceUnitName"
            :extraData="{
              companyCode: feeInfo.payableInvoiceCompanyCode,
              partnerTypes: 'HZHB02,HZHB03',
            }"
            @input="slectInvoiceUnitNo"
          ></search-table>
        </el-form-item>
      </el-col>
      <!-- 发票类型 -->
      <el-col :span="6">
        <el-form-item :label="$t('addInvoice.billInfo.invoiceType')" prop="invoiceType">
          <el-select
            style="width: 100%"
            v-model="feeInfo.invoiceType"
            @change="selectInvoiceType"
            :placeholder="this.$t('addInvoice.billInfo.invoiceType')"
            :disabled="detail"
          >
            <el-option
              v-for="item in invoiceTypeList"
              :key="item.id"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <!-- 发票编号 -->
      <!-- 胡家铭： 现在有个情况 就是进项发票的发票号能不能设置成15位 之前客户给的太长了sap那边会报错  -->
      <el-col :span="6">
        <el-form-item prop="invoiceCode" :label="this.$t('addInvoice.billInfo.invoiceCode')">
          <el-input :disabled="detail" v-model="feeInfo.invoiceCode" maxlength="15"></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="24">
      <!-- 发票张数 -->
      <el-col :span="6">
        <el-form-item prop="invoiceNumber" :label="this.$t('addInvoice.billInfo.invoiceNumber')">
          <el-input
            :disabled="detail"
            type="number"
            v-model="feeInfo.invoiceNumber"
            maxlength="5"
          ></el-input>
        </el-form-item>
      </el-col>
      <!-- 币种 -->
      <el-col :span="6">
        <el-form-item prop="currencyCode" :label="this.$t('addInvoice.billInfo.currencyCode')">
          <el-select
            filterable
            style="width: 100%"
            v-model="feeInfo.currencyCode"
            @change="selectCurrency"
            :placeholder="this.$t('addInvoice.billInfo.currencyCode')"
            :disabled="detail"
          >
            <el-option
              v-for="item in currencyList"
              :key="item.currencyCode"
              :label="item.currencyName"
              :value="item.currencyCode"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="24">
      <!-- 发票原币总金额 -->
      <el-col :span="6">
        <el-form-item
          prop="originalTotalAmount"
          :label="this.$t('addInvoice.billInfo.originalTotalAmount')"
        >
          <el-input :value="toLocaleString(feeInfo.originalTotalAmount)" disabled></el-input>
        </el-form-item>
      </el-col>
      <!-- 原币不含税总金额 -->
      <el-col :span="6">
        <el-form-item
          prop="originalTotalWithoutTaxAmount"
          :label="this.$t('addInvoice.billInfo.originalTotalWithoutTaxAmount')"
        >
          <el-input
            :value="toLocaleString(feeInfo.originalTotalWithoutTaxAmount)"
            disabled
          ></el-input>
        </el-form-item>
      </el-col>
      <!-- 原币税额 -->
      <el-col :span="6">
        <el-form-item
          prop="originalTaxAmount"
          :label="this.$t('addInvoice.billInfo.originalTaxAmount')"
        >
          <el-input :value="toLocaleString(feeInfo.originalTaxAmount)" disabled></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="24">
      <!--汇率类型/汇率-->
      <el-col :span="6">
        <el-form-item
          prop="exchangeRate"
          class="rate"
          :label="this.$t('addInvoice.billInfo.exchangeType')"
        >
          <el-col :span="11" class="rate-type" style="padding: 0">
            <el-select
              filterable
              v-model="feeInfo.exchangeType"
              :placeholder="this.$t('addInvoice.billInfo.exchangeTypePlaceholder')"
              :disabled="detail"
              @change="getTaxRate"
            >
              <el-option
                v-for="item in exchangeTypeList"
                :key="item.id"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="2" style="padding: 0; color: transparent">-</el-col>
          <el-col :span="11" style="padding: 0">
            <el-input :disabled="exchangeRateDisabled" v-model="feeInfo.exchangeRate"></el-input>
          </el-col>
        </el-form-item>
      </el-col>
      <!--
      <el-col :span="6">
        <el-form-item prop="exchangeRate" :label='this.$t("addInvoice.billInfo.exchangeRate")'>
            <el-input
            :disabled="detail"
            v-model="feeInfo.exchangeRate"
            disabled
          ></el-input>
        </el-form-item>
      </el-col>
      -->
      <!--汇率日期-->
      <el-col :span="6">
        <el-form-item prop="exchangeDate" :label="this.$t('addInvoice.billInfo.exchangeDate')">
          <el-date-picker
            :disabled="detail"
            @change="selectTaxRate"
            v-model="feeInfo.exchangeDate"
            style="width: 100%"
            type="date"
            value-format="yyyy-MM-dd"
            format="yyyy-MM-dd"
          ></el-date-picker>
        </el-form-item>
      </el-col>
      <!-- 归属日期 -->
      <!-- <el-col :span="6">
        <el-form-item prop="belongPeriod" :label="this.$t('addInvoice.billInfo.belongPeriod')">
          <el-date-picker
            :disabled="detail"
            v-model="feeInfo.belongPeriod"
            style="width: 100%"
            type="date"
            value-format="yyyy-MM-dd"
            format="yyyy-MM-dd"
          ></el-date-picker>
        </el-form-item>
      </el-col> -->
      <!-- 单据编号 -->
      <el-col :span="6">
        <el-form-item prop="documentCode" :label="this.$t('addInvoice.billInfo.documentCode')">
          <el-input v-model="feeInfo.documentCode" disabled></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="24">
      <!-- 本币总金额 -->
      <el-col :span="6">
        <el-form-item
          prop="domesticTotalAmount"
          :label="this.$t('addInvoice.billInfo.domesticTotalAmount')"
        >
          <el-input :value="toLocaleString(feeInfo.domesticTotalAmount)" disabled></el-input>
        </el-form-item>
      </el-col>
      <!-- 本币不含税金额 -->
      <el-col :span="6">
        <el-form-item
          prop="domesticTotalWithoutTaxAmount"
          :label="this.$t('addInvoice.billInfo.domesticTotalWithoutTaxAmount')"
        >
          <el-input
            :value="toLocaleString(feeInfo.domesticTotalWithoutTaxAmount)"
            disabled
          ></el-input>
        </el-form-item>
      </el-col>
      <!-- 本币税额 -->
      <el-col :span="6">
        <el-form-item
          prop="domesticTaxAmount"
          :label="this.$t('addInvoice.billInfo.domesticTaxAmount')"
        >
          <el-input :value="toLocaleString(feeInfo.domesticTaxAmount)" disabled></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="24">
      <!-- 备注 -->
      <el-col :span="24">
        <el-form-item prop="mark" :label="this.$t('addInvoice.billInfo.mark')">
          <el-input :disabled="detail" v-model="feeInfo.mark" maxlength="256"></el-input>
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
</template>

<script>
  import { mapState } from 'vuex';
  // import ajaxSelect from '@/components/form-item/ajax-select';
  import API from '@/api/financeCenter/payables';
  import searchTable from '@/components/form-item/search-table';
  import DictSelect from '@/components/DictSelect';
  import { fmoney } from '@/common/js/util';

  export default {
    name: 'feeInfo',
    components: {
      // ajaxSelect,
      searchTable,
      DictSelect,
    },

    props: ['feeInfo', 'companyList', 'detail', 'canEdit', 'fromContract'],
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
        // 汇率类型
        exchangeTypeList(state) {
          if (state.dict.dictList.length > 10) {
            return state.dict.dictList.find((it) => it.dictType == 'exchange_type').dictList;
          }
        },
        // 税务分类
        taxTypeList(state) {
          if (state.dict.dictList.length > 10) {
            return state.dict.dictList.find((it) => it.dictType == 'tax_type').dictList;
          }
        },
        // 发票类型
        invoiceTypeList(state) {
          if (state.dict.dictList.length > 10) {
            return state.dict.dictList.find((it) => it.dictType == 'invoice_type').dictList;
          }
        },
      }),
      rules() {
        // var originalTotalAmountValidate = (rule, value, callback) => {
        //   //当发票类型 选择蓝票时，校验发票原币总金额>0;当选择红票是，校验发票原币总金额<0
        //   if (this.feeInfo.invoiceType === 'invoice' && value <= 0) {
        //     callback(new Error('发票原币总金额>0'));
        //   } else if (this.feeInfo.invoiceType === 'creditMemo' && value >= 0) {
        //     callback(new Error('发票原币总金额<0'));
        //   } else {
        //     callback();
        //   }
        // };
        return {
          payableInvoiceCompanyCode: [
            {
              required: true,
              message: this.$t('addInvoice.billInfo.companyNoPlaceholder'),
              trigger: ['blur', 'change'],
            },
          ],
          issuingOffice: [
            {
              required: true,
              message: this.$t('addInvoice.billInfo.issuingOfficePlaceholder'),
              trigger: ['blur', 'change'],
            },
          ],
          invoiceType: [
            {
              required: true,
              message: this.$t('addInvoice.billInfo.invoiceTypePlaceholder'),
              trigger: ['blur', 'change'],
            },
            // { validator: invoiceTypeValidate, trigger: ["blur", "change"] }
          ],
          invoiceUnitName: [
            {
              required: true,
              message: this.$t('addInvoice.billInfo.invoiceUnitNamePlaceholder'),
              trigger: ['blur', 'change'],
            },
            // { validator: invoiceTypeValidate, trigger: ["blur", "change"] }
          ],

          invoiceCode: [
            {
              required: true,
              message: this.$t('addInvoice.billInfo.invoiceNoPlaceholder'),
              trigger: ['blur', 'change'],
            },
          ],
          currencyCode: [
            {
              required: true,
              message: this.$t('addInvoice.billInfo.currencyPlaceholder'),
              trigger: ['blur', 'change'],
            },
          ],
          exchangeRate: [
            {
              required: true,
              message: this.$t('addInvoice.billInfo.exchangeRatePlaceholder'),
              trigger: ['blur', 'change'],
            },
          ],
          mark: [
            {
              required: false,
              message: this.$t('addInvoice.billInfo.remarksPlaceholder'),
              trigger: ['blur', 'change'],
            },
          ],
          originalTotalAmount: [
            // { required: false, validator: originalTotalAmountValidate, trigger: ["blur", "change"] }
          ],
          // belongPeriod: [
          //   {
          //     required: true,
          //     message: this.$t('addInvoice.billInfo.belongPeriod'),
          //     trigger: ['blur', 'change'],
          //   },
          // ],
          invoiceUnitNo: [{ required: true, trigger: ['blur', 'change'] }],
          exchangeDate: [{ required: true }],
        };
      },
      exchangeRateDisabled() {
        return (
          this.feeInfo.currencyCode == this.feeInfo.companyCurrencyCode ||
          this.feeInfo.exchangeType == 'Cooperate'
        );
      },
    },
    watch: {
      baseDataRules: function () {
        this.$nextTick(() => {
          this.$refs.baseData.clearValidate();
        });
      },
    },
    data() {
      return {
        isIncludeOutboundExpense: this.feeInfo.isIncludeOutboundExpense,
        isInsureTypeList: [
          { id: '0', name: '否' },
          { id: '1', name: '是' },
        ],
        editConfig: {},
        tableToolbar: {},
        baseDataRules: {}, // 基本数据表单校验规则
        currencyList: [], //币种列表
        currencyCode: '', //选择币种名称
      };
    },
    mounted() {
      this.getCurrencyList();
    },
    methods: {
      changeValue(value) {
        this.isIncludeOutboundExpense = value;
      },
      // 选择公司代码
      selectCompany(v) {
        let companyObj = this.companyList.find((i) => i.personCompanyCode === v);
        const payableInvoiceCompanyName = companyObj ? companyObj.personCompanyName : '';
        this.feeInfo.payableInvoiceCompanyName = payableInvoiceCompanyName;

        this.feeInfo.invoiceUnitNo = '';
        this.feeInfo.invoiceUnitName = '';
        this.$emit('selectCompany', v);
        this.selectCompanyCurrency(v);
      },
      // 获取币种列表
      getCurrencyList() {
        this.$baseRequest.getCurrency().then((res) => {
          this.currencyList = res;
        });
      },
      // 选择制单人
      selectPayableInvoiceCreatePerson(row) {
        this.feeInfo.payableInvoiceCreatePersonName = row[0].personName;
        this.feeInfo.payableInvoiceCreatePersonNo = row[0].personNo;
      },
      // 获取公司对应本币位
      selectCompanyCurrency(companyCode) {
        this.$baseRequest.getLedger(companyCode).then((res) => {
          if (res.length > 0) {
            //如果换公司，则币种都默认变化
            this.feeInfo.companyCurrencyCode = res[0].currencyCode;
            this.feeInfo.currencyCode = res[0].currencyCode;
            this.feeInfo.companyCurrencyCode = res[0].currencyCode; //
            //默认汇率类型
            this.feeInfo.exchangeType = res[0].defaultExchangeType;
            if (!this.feeInfo.companyCurrencyCode && this.feeInfo.currencyCode) {
              //没有本币位
              this.$set(this.feeInfo, 'exchangeRate', null);
            }
            this.selectTaxRate();
          } else {
            //没有查询到公司账套
            this.feeInfo.companyCurrencyCode = null;
            this.feeInfo.currencyCode = null;
            this.feeInfo.exchangeType = null;
            this.feeInfo.exchangeRate = null;
            this.$alert(this.$t('addInvoice.warnInfo.ledgerInfo'));
          }
        });
      },
      //获取汇率
      getTaxRate() {
        if (this.feeInfo.currencyCode || this.feeInfo.companyCurrencyCode) {
          // const { tenantCode, companyCode, departmentCode } = this.userInfo;
          const params = {
            fromCurrencyCode: this.feeInfo.currencyCode,
            toCurrencyCode: this.feeInfo.companyCurrencyCode,
            exchangeDate: this.feeInfo.exchangeDate,
            exchangeType: this.feeInfo.exchangeType,
          };
          this.$baseRequest.getRate(params).then((res) => {
            if (res) {
              this.feeInfo.exchangeRate = res.positiveRate;
            } else {
              this.feeInfo.exchangeRate = null;
              this.$message({ showClose: true, message: '缺少对应汇率，请维护', type: 'error' });
            }
          });
        }
      },
      // 千分位
      toLocaleString(num) {
        return num && fmoney(num, 2);
      },
      // 选择币种
      selectCurrency(v) {
        this.feeInfo.currencyCode = v;
        this.selectTaxRate();
        this.$emit('changeCurrency');
      },
      // 汇率值获取
      selectTaxRate() {
        // let taxRate;
        console.log('selectTaxRate');
        if (
          this.feeInfo.companyCurrencyCode &&
          this.feeInfo.currencyCode &&
          this.feeInfo.companyCurrencyCode === this.feeInfo.currencyCode
        ) {
          // this.feeInfo.exchangeType = 'User'
          this.feeInfo.exchangeRate = 1;
        } else if (this.feeInfo.companyCurrencyCode && this.feeInfo.companyCurrencyCode) {
          this.getTaxRate();
        }
      },
      // 发票类型修改
      selectInvoiceType() {
        this.$emit('resetRowInfo');
        // this.$refs['feeInfo'].validateField('originalTotalAmount', (valid) => {
        //   if (valid) {
        //   } else {
        //   }
        // });
      },
      // 获取默认对账科目
      getPayableAccount(partnerCode) {
        const params = {
          partnerCode,
        };
        this.$axios.get(API.GET_PROCUREMENT_RECONCILATION_SUBJECT, params).then((res) => {
          if (0 == res.data.code) {
            this.$set(
              this.feeInfo,
              'payableAccount',
              res.data.data.procurementReconciliationSubject || null
            );
          }
        });
      },
      // 单位选择
      slectInvoiceUnitNo(e) {
        this.feeInfo.invoiceUnitNo = e[0].partnerCode;
        this.feeInfo.invoiceUnitName = e[0].partnerZhName;
        if (e[0].partnerCode) this.getPayableAccount(e[0].partnerCode);
        this.$emit('resetRowInfo');
      },
      // 校验
      getVal() {
        let flag = false;
        this.$refs.feeInfo.validate((valid) => {
          if (valid) {
            flag = true;
          } else {
            flag = false;
          }
        });
        return flag ? this.feeInfo : false;
      },
    },
  };
</script>
<style lang="scss" scoped>
  .rate .el-form-item__content {
    display: flex;
  }
</style>
